import { render, staticRenderFns } from "./MainInfoColumnBlackAndYellow.vue?vue&type=template&id=b8e5aed6&scoped=true&"
import script from "./MainInfoColumnBlackAndYellow.vue?vue&type=script&lang=js&"
export * from "./MainInfoColumnBlackAndYellow.vue?vue&type=script&lang=js&"
import style0 from "./MainInfoColumnBlackAndYellow.vue?vue&type=style&index=0&id=b8e5aed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e5aed6",
  null
  
)

export default component.exports